import {
  COURSE_EVAL_LIST_REQUEST,
  COURSE_EVAL_LIST_SUCCESS,
  COURSE_EVAL_LIST_FAILURE,
  COURSE_EVAL_REQUEST,
  COURSE_EVAL_SUCCESS,
  COURSE_EVAL_FAILURE,
  COURSE_EVAL_SAVE_REQUEST,
  COURSE_EVAL_SAVE_SUCCESS,
  COURSE_EVAL_SAVE_FAILURE,
  COURSE_EVAL_SUBMIT_REQUEST,
  COURSE_EVAL_SUBMIT_SUCCESS,
  COURSE_EVAL_SUBMIT_FAILURE,
} from '../constants/ActionTypes';

const initialState = {
  evaluationsLoaded: false,
  evaluationsError: null,
  hasError: false,
  evaluations: [],
  evaluationError: null,
  hasEvaluationError: false,
  evaluationById: {},
  evaluationLoadedById: {},
  evaluationSaving: false,
  evaluationSubmitting: false,
};
export default function CourseEvaluationReducer(state = initialState, action) {
  switch (action.type) {
    case COURSE_EVAL_LIST_REQUEST: {
      return {
        ...state,
        evaluationsLoaded: false,
        evaluationsError: null,
        hasError: false,
      };
    }
    case COURSE_EVAL_LIST_SUCCESS:
      return {
        ...state,
        evaluationsLoaded: true,
        evaluations: action.evaluations,
      };
    case COURSE_EVAL_LIST_FAILURE:
      return {
        ...state,
        evaluationsLoaded: true,
        evaluationsError: action.evaluationsError,
        hasError: true,
      };
    case COURSE_EVAL_REQUEST:
      return {
        ...state,
        evaluationLoadedById: {
          ...state.evaluationLoadedById,
          [action.CourseAttendeeID]: false,
        },
        evaluationById: {
          ...state.evaluationById,
          [action.CourseAttendeeID]: null,
        },
        evaluationError: null,
        hasEvaluationError: false,
      };
    case COURSE_EVAL_SUCCESS:
      return {
        ...state,
        evaluationLoadedById: {
          ...state.evaluationLoadedById,
          [action.CourseAttendee.CourseAttendeeID]: true,
        },
        evaluationById: {
          ...state.evaluationById,
          [action.CourseAttendee.CourseAttendeeID]: {
            CourseAttendee: action.CourseAttendee,
            CourseEvaluation: action.CourseEvaluation,
            CourseEvaluationAnswers: action.CourseEvaluationAnswers,
          },
        },
      };
    case COURSE_EVAL_FAILURE:
      return {
        ...state,
        evaluationLoadedById: {
          ...state.evaluationLoadedById,
          [action.CourseAttendeeID]: true,
        },
        evaluationError: action.evaluationError,
        hasEvaluationError: true,
      };
    case COURSE_EVAL_SAVE_REQUEST:
      return {
        ...state,
        evaluationSaving: true,
        evaluationError: null,
        hasEvaluationError: false,
      };
    case COURSE_EVAL_SAVE_SUCCESS:
      return {
        ...state,
        evaluationSaving: false,
      };
    case COURSE_EVAL_SAVE_FAILURE:
      return {
        ...state,
        evaluationSaving: false,
        evaluationError: action.evaluationError,
        hasEvaluationError: true,
      };
    case COURSE_EVAL_SUBMIT_REQUEST:
      return {
        ...state,
        evaluationSubmitting: true,
        hasEvaluationError: false,
      };
    case COURSE_EVAL_SUBMIT_SUCCESS:
      return {
        ...state,
        evaluationSubmitting: false,
      };
    case COURSE_EVAL_SUBMIT_FAILURE:
      return {
        ...state,
        evaluationSubmitting: false,
        evaluationError: action.evaluationError,
        hasEvaluationError: true,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/CourseEvaluationReducer.js